import type {Deal as ServerDeal} from 'src/types/serverTypes/Moblico';
export default class Deal {
  externalServiceId: string | number;
  message: string;
  endDate: string;
  name: string;
  currentGoalAmount: number;
  currentGoalQuantity: number;
  targetGoalAmount: number;
  targetGoalQuantity: number;
  dealStatus: number;
  image: string | null;
  legalese: string;
  redeemedCount: number;
  numberOfUsesPerCode: number;
  promotionText: string;
  isRead: boolean;
  description?: string;

  constructor(serverDeal: ServerDeal) {
    this.externalServiceId = serverDeal.id;
    this.message = serverDeal.message;
    this.endDate = serverDeal.endDate as any;
    this.name = serverDeal.name;
    this.currentGoalAmount = serverDeal.currentGoalAmount;
    this.currentGoalQuantity = serverDeal.currentGoalQuantity;
    this.targetGoalAmount = serverDeal.targetGoalAmount;
    this.targetGoalQuantity = serverDeal.targetGoalQuantity;
    this.dealStatus = serverDeal.dealStatus;
    this.image = serverDeal.image?.url;
    this.legalese = serverDeal.legalese;
    this.redeemedCount = serverDeal.redeemedCount;
    this.numberOfUsesPerCode = serverDeal.numberOfUsesPerCode;
    this.promotionText = serverDeal.promoText;
    this.isRead = serverDeal.isRead;
    this.description = serverDeal?.description;
  }
}
